export type GetExamsListParams = {
	page: number;
	size: number;
	'exam-description'?: string;
	'database-name'?: string;
	'service-code'?: string;
	signal?: AbortSignal;
};

export enum ExamStatusEnum {
	LABORATORY = 'L',
	IMAGE = 'I',
}

export type ExamItemType = {
	serviceCode: number;
	examType: string;
	requestDate: string;
	requestTime: string;
	examDescription: string;
	examStatus: ExamStatusEnum;
	requestingDoctorName: string;
};

export type GetExamsListModel = {
	content: ExamItemType[];
	totalElements: number;
};

export interface GetExamsList {
	get: (params: GetExamsListParams) => Promise<GetExamsListModel>;
}
